import dayjs from "dayjs";

import { SET_META_INFO, CLEAR_SENSITIVE_META_INFO } from ":mutations";
import { REQUEST_META_INFO } from ":actions";

import { requestMetaInfo } from "%services/meta/MetaService";

const state = {
  version: null,
  year: null,
  build: null
};

const mutations = {
  [SET_META_INFO](state, { version, year, build }) {
    state.version = version;
    state.year = year;
    state.build = build;
  },

  [CLEAR_SENSITIVE_META_INFO](state) {
    state.version = null;
    state.build = null;
  }
};

const actions = {
  [REQUEST_META_INFO]({ commit }) {
    return requestMetaInfo().then(response =>
      commit(SET_META_INFO, {
        version: response.data.version,
        year: dayjs(response.data.currentDate).year(),
        build: response.data.buildDate && dayjs(response.data.buildDate)
      })
    );
  }
};

const getters = {};

export default {
  state,
  mutations,
  actions,
  getters
};
